import { render, staticRenderFns } from "./MarketOverview.vue?vue&type=template&id=155040b8&scoped=true&"
import script from "./MarketOverview.vue?vue&type=script&lang=ts&"
export * from "./MarketOverview.vue?vue&type=script&lang=ts&"
import style0 from "./MarketOverview.vue?vue&type=style&index=0&id=155040b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155040b8",
  null
  
)

export default component.exports